import { getImageUrl } from "@/methods/iconHelpers";

export const navPartnerRoutes = [
    // Dashboard not required for MVP
    // {
    //     title: "Dashboard",
    //     iconPath: getImageUrl("icons/24x24/ic24-home.svg"),
    //     route: "/partner/overview",
    //     requiredPermissions: [],
    //     multiplePaths: false,
    //     requiredPartnerPermissions: [],
    // },
    {
        title: "Transactions",
        iconPath: getImageUrl("icons/24x24/ic24-transaction.svg"),
        route: "/partner/transactions",
        requiredPermissions: [],
        multiplePaths: false,
        requiredPartnerPermissions: [],
        subitems: [
            {
                title: "Order Payments",
                iconPath: getImageUrl("icons/16x16/ic16-placeholder.svg"),
                route: "/partner/transactions/order-payments",
                requiredPermissions: [],
                multiplePaths: false,
                requiredPartnerPermissions: [],
            },
        ],
    },
    {
        title: "Support",
        iconPath: getImageUrl("icons/24x24/ic24-help.svg"),
        route: "/partner/support",
        requiredPermissions: [],
        matchPath: ["/partner/support"],
        multiplePaths: false,
        requiredPartnerPermissions: [],
    },
    {
        title: "Logout",
        iconPath: getImageUrl("icons/24x24/ic24-log-out.svg"),
        route: "logout",
        requiredPermissions: [],
        multiplePaths: false,
        requiredPartnerPermissions: [],
    },
];

export const noPermissionsPartnerRoutes = [
    {
        title: "Logout",
        iconPath: getImageUrl("icons/24x24/ic24-log-out.svg"),
        route: "logout",
        requiredPermissions: [],
        multiplePaths: false,
        requiredPartnerPermissions: [],
    },
];

export const checkFirstTwoRouteSegmentsMatch = (
    navbarRoute: string,
    currentRoute: string,
) => {
    /**
     * Compares the navbar route and the current route the user is on and
     * checks that the first two segments match to highlight the correct section
     * in the sidebar navigation.
     * Eg expected output:
     * "/partner/bacs/mandates" === "/partner/bacs/files" returns true
     * "/partner/transactions" === "partner/transactions" return true
     * "/partner/transactions" === "partner/posting-report" return false
     * "/new-partner/bacs/mandates" === "/partner/bacs/files" returns false
     * "/partner/transactions/mandates" === "/partner/bacs/files" returns false
     * "/partner/bacs/mandates" === "/partner/transactions" returns false
     *
     * @param {string} navbarRoute - the route in the navigation sidebar menu
     * @param {string} currentRoute - the route the user is on
     * @returns {boolean}
     */

    // Remove leading and trailing slashes
    navbarRoute = navbarRoute.replace(/^\/|\/$/g, "");
    currentRoute = currentRoute.replace(/^\/|\/$/g, "");

    // Split strings into segments
    const segments1 = navbarRoute.split("/");
    const segments2 = currentRoute.split("/");

    // Check if both strings have at least two segments
    if (segments1.length < 2 || segments2.length < 2) {
        return false;
    }

    // Compare first two segments
    return segments1[0] === segments2[0] && segments1[1] === segments2[1];
};
